import { CmsGift } from '@hyphengroup/cms-components/types/cmsProduct';
import { getGiftLabels } from '@hyphengroup/cms-components/utils/helpers/giftLabels';
import { Translated } from '@hyphengroup/cms-components/utils/translations/staticText';
import { RewardCardTranslations } from './i18n';
import { RewardCardImage } from './RewardCardImage';

type ItemListRewardCardProps = CmsGift & {
  staticText: Translated<typeof RewardCardTranslations>;
};

export const ItemListRewardCard: React.FC<ItemListRewardCardProps> = ({
  desktop_image,
  mobile_image,
  gift_title,
  gift_value,
  staticText,
}) => {
  const { title, subtitle } = getGiftLabels(
    { gift_title, gift_value },
    staticText,
  );

  return (
    <div>
      <div className="flex items-center gap-spacing/gap/x">
        <div>
          <div className="hidden md:block">
            {(desktop_image || mobile_image) && (
              <RewardCardImage
                altText={gift_title}
                imageSrc={desktop_image || mobile_image}
                size="small"
              />
            )}
          </div>
          <div className="block md:hidden">
            {(mobile_image || desktop_image) && (
              <RewardCardImage
                altText={gift_title}
                imageSrc={mobile_image || desktop_image}
                size="small"
              />
            )}
          </div>
        </div>
        <div className="flex flex-col gap-2">
          {gift_title && (
            <div className="mhg-alpha-subheading-2 text-text-primary">
              {gift_title}
            </div>
          )}
          {(title || subtitle) && (
            <div className="mhg-alpha-typography-body-2 flex items-center gap-1 text-text/secondary-lighter">
              {title && <span>{title}</span>}
              {subtitle && title && <span>·</span>}
              {subtitle && <span>{subtitle}</span>}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
